registerComponent("product-blocks/product-objective", function (component) {

});
